import { render } from "./last-location-filter-section.vue?vue&type=template&id=1c27145e&scoped=true&ts=true"
import script from "./last-location-filter-section.vue?vue&type=script&lang=ts"
export * from "./last-location-filter-section.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c27145e"]])

export default __exports__